import {Component, OnDestroy, OnInit} from '@angular/core';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {
  QuickSelectionModel, QuickSelectionModelId,
  SelectionEventModel,
  TreeItemFlatNode,
  TreeItemNode
} from '@shared/models/tree-selector.models';
import {DialogModel} from '@shared/models/dialog.model';
import {map, takeUntil} from 'rxjs/operators';
import {ActivityFilterService} from '../../../../services/activity-filter.service';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';

@Component({
    standalone: false,
    selector: 'particle-activity-filter-project-selector',
  templateUrl: './activity-filter-project-selector.component.html',
  styleUrls: ['./activity-filter-project-selector.component.scss']
})
export class ActivityFilterProjectSelectorComponent implements OnInit, IDialogView, OnDestroy {
  data: DialogModel;
  selectedProjects: any[] = [];
  solutionSelectorTitle: string;
  selectorData$: BehaviorSubject<TreeItemNode[]> = new BehaviorSubject([]);
  solutionSelectorData$: BehaviorSubject<TreeItemNode[]> = new BehaviorSubject([]);
  itemViewerName: string;
  isParentNodeCollapsible$: BehaviorSubject<boolean> = new BehaviorSubject(true);
  quickSelections$: Observable<QuickSelectionModel[]> = new Observable<QuickSelectionModel[]>();
  selectedProjectsId: Array<string> = [];
  valueChanged: boolean = false;
  allRecords: boolean = false;
  private ngUnsubscribe = new Subject<void>();
  private allProjects: Array<any> = [];

  constructor(private activityFilterService: ActivityFilterService) {
    this.quickSelections$ = of([
      {
        name: 'All Projects',
        id  : QuickSelectionModelId.ALL
      },
      {
        name: 'None',
        id  : QuickSelectionModelId.NONE
      }
    ]);
  }

  ngOnInit() {
    this.selectedProjectsId = this.data.input.selectedProjectsId;
    this.allRecords = this.data.input.allRecords;
    if(!this.selectedProjectsId) {
      this.selectedProjectsId = [];
    }
    this.setUpSolutionSelector();
  }


  onOkClicked(): boolean {
    //console.log('[all projects count] ', this.allProjects.length, this.selectedProjectsId.length);
    if(this.allRecords && !this.valueChanged) {
      this.data.input.selectedProjectsId = this.allProjects.map(p => p.id);
    } else {
      this.data.input.selectedProjectsId = this.valueChanged ? this.selectedProjects.map(project => project.id): this.selectedProjectsId;
    }
    this.data.input.allItemsSelected = this.data.input.selectedProjectsId.length === this.allProjects.length;
    return true;
  }

  setUpSolutionSelector() {
    this.solutionSelectorTitle = 'Projects';
    this.itemViewerName = 'SolutionItemViewerComponent';
    this.isParentNodeCollapsible$.next(true);
    this.getTreeData();
  }

  onProjectSelectionChanged($event: SelectionEventModel) {
    this.selectedProjects = $event.selectedTreeNodes.filter(o => o.item.isChecked === true).map(o => o.item);
    this.valueChanged = true;
    //console.log('on project selection');
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  onQuickSelectionClick($event: QuickSelectionModel) {
    //console.log($event);
  }

  private getTreeData() {
    this.activityFilterService.getProjects()
      .pipe(
        map(res => this.prepareTreeData(res)),
        takeUntil(this.ngUnsubscribe))
      .subscribe(res =>
        this.solutionSelectorData$.next(res)
      );
  }

  private convertToTreeItemNode(item: any, solutionId: string): TreeItemNode {
    const treeItem = new TreeItemNode();
    treeItem.id = item.id;
    if (item && item.children && item.children.length) {
      treeItem.children = new Array<TreeItemNode>();
      item.children.forEach(itemChild => {
        treeItem.children.push(this.convertToTreeItemNode(itemChild, solutionId));
      });
    }
    let isChecked = this.allRecords ? true: this.selectedProjectsId.indexOf(item.id) === -1 ? false: true;
    treeItem.item = {
      id: item.id,
      name: item.name,
      solutionId: solutionId,
      featureId: item.featureId,
      description: item.featureId,
      isChecked: isChecked,
      isTool: item.isTool,
      route: item.route,
      expandable: false
    };
    return treeItem;
  }

  private prepareTreeData(projects: Array<any> = []): TreeItemNode[] {
    //console.log('[all projects] ', projects);
    this.allProjects = projects;
    //updating projects based on current projects list
    this.selectedProjectsId = this.selectedProjectsId.filter(pId => this.allProjects.findIndex(p => p.id === pId) !== -1);
    const treeData: Array<TreeItemNode> = [];
    projects.forEach(treeItem => {
      treeData.push(this.convertToTreeItemNode(treeItem, treeItem.id));
    });
    return treeData;
  }
}
